import styled from 'styled-components';

export const Container = styled.div`
  div.border-master {
    border: 1px solid ${(props) => props.theme.$primary_green};
    border-radius: 4px;
  }

  div.border-super {
    border: 1px solid ${(props) => props.theme.$bg_blue};
    border-radius: 4px;
  }

  div.border-premium {
    border: 1px solid ${(props) => props.theme.$dark};
    border-radius: 4px;
  }

  div.card-header-premium {
    color: ${(props) => props.theme.$yellow};
    background-color: ${(props) => props.theme.$dark};
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
  }

  div.card-header-master {
    color: ${(props) => props.theme.$white};
    background-color: ${(props) => props.theme.$primary_green};
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    height: 48px;
    border-radius: 4px 4px 0px 0px;
  }

  div.card-header-super {
    color: ${(props) => props.theme.$white};
    background-color: ${(props) => props.theme.$bg_blue};
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
  }

  div.card-header-basic {
    color: ${(props) => props.theme.$white};
    background-color: ${(props) => props.theme.$primary_green};
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    border-radius: 19px 19px 0px 0px;
  }

  div.card-black-friday {
    color: ${(props) => props.theme.$white};
    background-color: ${(props) => props.theme.$black};
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
  }

  div.card-header-additional_services {
    color: ${(props) => props.theme.$white};
    background-color: #956cca;
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
  }

  div h5.card-title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  #summary-value {
    border-radius: 4px;
    margin-top: -19px;
  }

  .amount-master {
    color: ${(props) => props.theme.$primary_green};
    font-weight: 500;
    line-height: 28px;
  }
  .amount-super {
    color: ${(props) => props.theme.$bg_blue};
    font-weight: 500;
    line-height: 28px;
  }
  .amount-premium {
    color: ${(props) => props.theme.$gold};
    font-weight: 500;
    line-height: 28px;
  }
  .discount-percentage-master {
    color: ${(props) => props.theme.$primary_green};
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  .discount-percentage-super {
    color: ${(props) => props.theme.$bg_blue};
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
  .discount-percentage-premium {
    color: ${(props) => props.theme.$gold};
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  p.summary {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  .img-list {
    left: 0%;
    right: 0%;
    top: 9.72%;
    bottom: 9.72%;
  }

  ul li {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }

  .card {
    border-radius: 4px 4px 0px 0px;
  }
  li {
    list-style-type: none;
  }

  div.card-plans-new {
    border: 1px solid #c8c8c8;
    border-radius: 20px;
  }

  div.card-header-new {
    color: ${(props) => props.theme.$white};
    background-color: ${(props) => props.theme.$primary_green};
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    border-radius: 19px 19px 0px 0px;
  }
`;
